import { SESSION_STORAGE_CONSTANTS } from '@/shared/constants/ds-constants';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { MY_BRIEFING_ROUTE_NAME_ACTIVE, MY_CREATE_ROUTE_NAME_ACTIVE, SCRAP_AGENT_ROUTE_NAME_ACTIVE, VERSION } from '@/constants';
import TranslationService from '@/locale/translation.service';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import axios from 'axios';
import { Subscription } from 'rxjs';
import { namespace } from 'vuex-class';
import { PrincipalService } from '@/service/principal.service';
import { CmGroupsQueueMessage } from '@/shared/model/cm-group-queue-message.model';
import { IUserModel, UserModel } from '@/shared/model/users.model';
import { changeColorTheme, onErrorImageAvatar } from '@/util/common-util';
import BriefingService from '@/service/briefing.service';
import type { IBriefingPage, IReportPage } from '@/shared/model/briefing-widget.model';
import { isNullish } from '@/util/ds-util';
import { updateLocalStorageDsConnectomeLanguage, updateLocalStorageUserLanguage } from '@/util/localStorage-util';
import { checkIsGuestAccount } from '@/util/guest-util';
import { hideElementById } from '@/util/style-util';

const groupsManagerStore = namespace('groupsManagerStore');
const askGooverStore = namespace('askGooverStore');
const notificationViewState = namespace('notificationViewStateStore');
const navbarStore = namespace('navbarStore');
const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  methods: {
    checkIsGuestAccount,
    MY_BRIEFING_ROUTE_NAME_ACTIVE() {
      return MY_BRIEFING_ROUTE_NAME_ACTIVE;
    },
    MY_CREATE_ROUTE_NAME_ACTIVE() {
      return MY_CREATE_ROUTE_NAME_ACTIVE;
    },
    SCRAP_AGENT_ROUTE_NAME_ACTIVE() {
      return SCRAP_AGENT_ROUTE_NAME_ACTIVE;
    },
    isNullish,
    onErrorImageAvatar,
  },
  computed: {
    detailFeed() {
      return this.$store.getters.getDetailFeed;
    },
  },

  watch: {
    $route(route: any) {
      this.isShowMore = false;
    },
    detailFeed(value) {
      this.isDetailFeed = value;
    },
  },
  components: {},
})
export default class DsNavbar extends Vue {
  props: {
    state: boolean;
  };

  @Inject('translationService') private translationService: () => TranslationService;
  @Inject('principalService') private principalService: () => PrincipalService;
  @Inject('briefingService') private briefingService: () => BriefingService;

  @askGooverStore.Getter
  public getIsWaitingResponse: boolean;

  @appStoreState.Getter
  getIsLoadingUpdateLanguage!: boolean;

  public version = VERSION ? 'v' + VERSION : '';
  private currentLanguage = this.$store.getters.currentLanguage;
  private langKey = 'en';
  private hasAnyAuthorityValue = false;
  private avatar = '';
  private isEditing = false;
  public user;

  @groupsManagerStore.Action
  public loadUserContext!: (payload: {
    connectomeId: string;
    language: string;
  }) => Promise<{ status: string; message: string; result: any }>;

  @groupsManagerStore.Action
  public handleWebsocketMessage!: (message: CmGroupsQueueMessage) => Promise<{
    status: string;
    message: string;
    result: any;
  }>;

  @notificationViewState.Action
  public pressNotification!: (payload: { countPressNotification: number }) => void;

  private subscription?: Subscription;

  @navbarStore.Action
  public setCollectionLoadAc!: (payload: { newVal: boolean }) => void;

  @navbarStore.Action
  public setCollectionLoading!: (payload: { newVal: boolean }) => void;

  @navbarStore.Getter
  public isCollectionLoading!: boolean;

  @appStoreState.Getter
  getCurrentUserImageUri!: string;

  @appStoreState.Mutation
  public setCurrentUserImageUri!: (payload: any) => void;

  @appStoreState.Mutation
  public setColorTheme!: (payload: any) => void;

  @appStoreState.Getter
  getColorTheme!: string;

  @appStoreState.Getter
  getIsCallLoadBriefing!: boolean;

  @briefingStore.Getter
  public getTotalResources!: number;

  @briefingStore.Mutation
  public setTotalResources!: (payload: number) => void;

  @appStoreState.Mutation
  public setShowAddReference!: (payload?: any) => void;

  @appStoreState.Mutation
  public setIsOpenFirstStepDeleteAccountModal!: (payload?: any) => void;

  @appStoreState.Mutation
  public setIsOpenSecondStepDeleteAccountModal!: (payload?: any) => void;

  @appStoreState.Mutation
  public setIsOpenResetServiceModal!: (payload?: any) => void;

  @briefingStore.Getter
  public getSelectedReportPage!: IReportPage;

  @briefingStore.Getter
  public getSelectedBriefingPage!: IBriefingPage;

  @briefingStore.Getter
  public getSelectedSocialPage!: IBriefingPage;

  @appStoreState.Mutation
  public setIsShowDeleteBriefing!: (payload: any) => void;

  @appStoreState.Getter
  isDisabledLink!: boolean;

  @appStoreState.Mutation
  public setIsShowReportSettingReportType!: (payload?: boolean) => void;

  @briefingStore.Mutation
  public setStoreReferenceDocumentsForReport!: (payload: any) => void;

  @appStoreState.Mutation
  public setIsShowReportWarningCloseAfterEdit!: (payload?: boolean) => void;

  @appStoreState.Mutation
  public setShowEditReportRef!: (payload?: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupSubmitReport!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupSubmitReportSuccess!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsOpenPopupEditReferenceForPage!: (payload: boolean) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @briefingStore.Mutation
  public setIsForNewBriefing!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupRequiredLogin!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupRegister!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupLogin!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsShowPopupLogin!: boolean;

  @appStoreState.Getter
  public getIsShowPopupRegister!: boolean;

  private datePicker = {
    from: new Date().toISOString().split('T')[0],
    to: new Date().toISOString().split('T')[0],
  };
  private fromDate = '';
  private untilDate = '';
  public isDisabled = false;
  private dateTime = [];

  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  tempCurrentUserImageUri = 'content/images/avatar.png';
  lang = '';
  tempLastName = '';

  created() {
    window.addEventListener('storage', this.onStorageChange);

    this.getUserById();
    // this.tempCurrentUserImageUri = this.localStorageUser?.imageUrl;
    // this.setCurrentUserImageUri(this.localStorageUser?.imageUrl);
    this.langKey = this.currentLanguage;
    this.translationService().refreshTranslation(this.currentLanguage);
    // this.$root.$on('get-user-context', this.callApiGetContext);
    this.$root.$on('dateTime', this.changeDateTime);
    this.$root.$on('handleCloseModal', this.handleCloseModal);
  }

  mounted() {
    this.fetchTotalResource();
    $('.mx-icon-calendar').css('top', '18px');
  }

  beforeDestroy() {
    window.removeEventListener('storage', this.onStorageChange);
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  // get currentMyReportHref() {
  //   return !isNullish(this.getSelectedReportPage) && this.getSelectedReportPage.user_key
  //     ? `/my-report/${this.getSelectedReportPage.user_key}`
  //     : '/my-report';
  // }

  get currentMyBriefingHref() {
    return !isNullish(this.getSelectedBriefingPage) && this.getSelectedBriefingPage.bpId
      ? `/my-briefing/${this.getSelectedBriefingPage.bpId}`
      : '/my-briefing';
  }

  // get currentSocialBriefingHref() {
  //   return !isNullish(this.getSelectedSocialPage) && this.getSelectedSocialPage.bpId
  //     ? `/social-briefing/${this.getSelectedSocialPage.bpId}`
  //     : '/social-briefing';
  // }

  @Watch('getCurrentUserImageUri')
  onCurrentUserImageUriChange() {
    if (this.getCurrentUserImageUri) {
      this.tempCurrentUserImageUri = this.getCurrentUserImageUri;
    } else {
      this.tempCurrentUserImageUri = 'content/images/avatar.png';
    }
  }

  // callApiGetContext() {
  //   if (!this.isCollectionLoading) {
  //     this.setCollectionLoading({ newVal: true });
  //     this.loadUserContext({
  //       connectomeId: this.localStorageUser?.connectomeId,
  //       language: this.currentLanguage,
  //     }).then(res => {
  //       // console.log('*****[SVO]*****/(^^)/ loadUserContext', res);
  //       this.setCollectionLoadAc({ newVal: true });
  //       this.setCollectionLoading({ newVal: false });
  //     });
  // this.loadUserWorkspace({ connectomeId: connectomeTmp.connectomeId, language: this.currentLanguage }).then(res => {
  //   console.log('*****[SVO]*****/(^^)/ loadUserWorkspace', res);
  //   this.createUpsertWorkspaceFromBackend().then(res => {
  //     console.log('*****[SVO]*****/(^^)/ reload workspace in navbar1', res);
  //   });
  // });
  // }
  // this.getUserById();
  // }

  // @Watch('tokenProp')
  // setConnectome() {
  //   this.callApiGetContext();
  // }

  public logout(): void {
    this.handlerClose()
      .then(this.refreshLocalStorage)
      .catch(err => {
        this.refreshLocalStorage;
      });
  }

  async handlerClose() {
    if (this.principalService().getUserInfo()) {
      // const login = this.principalService().getUserInfo().login;
      // await axios.get('api/clearTimer/' + login).then();
      // const token = sessionStorage.getItem('ds-authenticationToken') || localStorage.getItem('ds-authenticationToken');
      await axios.get('api/removeToken').then();
    }
  }

  onStorageChange(event: StorageEvent) {
    if (event.key === 'currentLanguage') {
      if (event.newValue) {
        this.handleChangeUserLanguage(event.newValue);
      }
    }
  }

  refreshLocalStorage() {
    window.postMessage({ type: `START_LOGOUT_BROWSER_AGENT` }, '*');
    localStorage.removeItem('conversationId');
    localStorage.removeItem('modalState');
    localStorage.removeItem('localStorageUser');
    localStorage.removeItem('ds-connectome');
    localStorage.removeItem('card-data');
    localStorage.removeItem('stock-codes');
    localStorage.removeItem('loadingDataReportCardListLocalStorage');
    localStorage.removeItem('loadingDataReportToastListLocalStorage');
    localStorage.removeItem('localStorageReportBpIdListSubscribe');
    localStorage.removeItem('localStorageUser');
    localStorage.removeItem('lang');
    localStorage.removeItem('DDT_DATE');
    sessionStorage.removeItem(SESSION_STORAGE_CONSTANTS.FEED_STATUS_TRAINING);
    //localStorage.removeItem('ds-selectedConnectomeNode');
    this.$store.dispatch('groupsManagerStore/logout');
    this.$store.commit('logout');
    localStorage.removeItem('ds-authenticationToken');
    sessionStorage.removeItem('ds-authenticationToken');
    sessionStorage.setItem('requested-url', '/home');
    this.$root.$emit('bv::hide::modal', 'modal-my-info');
    // this.$root.$emit('bv::hide::modal', 'modal-alert-logout');
    // @ts-ignore
    window.$('#logoutModal').modal('hide');

    if (this.$route.name !== 'Home') {
      this.$router.push('/home');
    } else {
      this.$router.push('/home?t=' + Date.now().toString());
    }

    // this.$router.afterEach(() => {
    //   window.location.reload();
    // });
  }

  public login(): void {
    if (sessionStorage.getItem('requested-url') == '') {
      const url = this.$route.fullPath != '/register' && this.$route.fullPath != '/login' ? this.$route.fullPath : '/';
      sessionStorage.setItem('requested-url', url);
    }
    this.$router.push('/login', () => {});
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  get account() {
    return this.$store.getters.account;
  }

  get isGuest() {
    return this.account?.isGuest ?? false;
  }

  get isAccountReady() {
    return !!this.account;
  }

  get shortenedLastName() {
    if (this.account.lastName && !this.isGuest) {
      return this.account.lastName.length > 7 ? this.account.lastName.slice(0, 7) + '…' : this.account.lastName;
    }
    return this.account.langKey === 'en' ? 'Guest' : '게스트';
  }

  // public closePopupMyInfo(): void {
  //   this.$root.$emit('bv::hide::modal', 'modal-my-info');
  // }

  // public openPopupUserProfile(): void {
  //   this.closePopupMyInfo();
  //   this.$root.$emit('bv::show::modal', 'modal-user-profile');
  // }

  public get username(): string {
    return this.$store.getters.account ? this.$store.getters.account.login : '';
  }

  destroyed() {
    if (this.subscription) {
      try {
        this.subscription.unsubscribe();
        this.subscription = undefined;
      } catch (error) {
        console.log(error);
      }
    }
    // this.$root.$on('get-user-context', this.callApiGetContext);
  }

  openModalLogout() {
    this.$bvModal.show('modal-logged-out');
  }

  handleCloseModal() {
    this.setShowAddReference(false);
    this.setIsOpenFirstStepDeleteAccountModal(false);
    this.setIsOpenSecondStepDeleteAccountModal(false);
    this.setIsOpenResetServiceModal(false);
    this.setIsShowDeleteBriefing(false);
    this.setIsShowReportSettingReportType(false);
    this.setStoreReferenceDocumentsForReport([]);
    this.setIsShowReportWarningCloseAfterEdit(false);
    this.setShowEditReportRef(false);
    this.handleCloseBackDrop();
    this.setIsShowPopupSubmitReport(false);
    this.setIsShowPopupSubmitReportSuccess(false);
    this.setIsOpenPopupEditReferenceForPage(false);
    this.setIsForNewBriefing(false);
    this.setReferenceDocumentsForNewBriefing([]);
    this.setIsShowPopupLogin(false);
    this.setIsShowPopupRegister(false);
    this.setIsShowPopupRequiredLogin(false);
    hideElementById('buttonClosePopupPolicy', true);
    hideElementById('buttonClosePopupTermOfUse', true);
  }

  // lastName;
  // phoneNumber;
  // email;
  // imageUrl;

  // public fillPopupUserInfo(account) {
  // this.lastName = account?.lastName;
  // this.lastName = account.lastName;
  // this.phoneNumber = account?.phoneNumber;
  // this.email = account?.email;
  // this.avatarSync = account.imageUrl;
  // this.imageUrl = account?.imageUrl;
  // this.avatar = account?.imageUrl;
  // this.oldPhoneNumber = account.phoneNumber;
  // }

  public getUserById() {
    if (this.localStorageUser) {
      const res = { data: this.localStorageUser };
      this.user = res.data;
      // this.fillPopupUserInfo(res.data);

      if (res?.data?.langKey) {
        this.handleChangeUserLanguage(res?.data?.langKey);
      }

      if (res?.data.imageUrl) {
        this.tempCurrentUserImageUri = res.data.imageUrl;
        this.setCurrentUserImageUri(res.data.imageUrl);
      } else {
        this.tempCurrentUserImageUri = 'content/images/avatar.png';
      }
      if (res?.data.isGuest) {
        this.tempLastName = res.data.langKey === 'en' ? 'Guest' : '게스트';
      } else {
        this.tempLastName = res.data.lastName || '';
      }
      const storedTheme = localStorage.getItem('theme') || 'light';
      changeColorTheme(storedTheme);
      this.setColorTheme(storedTheme);
    }
  }

  handleChangeUserLanguage(newLanguage: any) {
    if (newLanguage && (newLanguage != this.currentLanguage || newLanguage != this.langKey || newLanguage != this.$i18n.locale)) {
      localStorage.setItem('currentLanguage', newLanguage);
      this.$store.commit('currentLanguage', newLanguage);
      this.translationService().refreshTranslation(newLanguage);
      this.$root.$emit('update-new-lang', newLanguage);
      this.user.langKey = newLanguage;
      updateLocalStorageDsConnectomeLanguage(newLanguage);
      updateLocalStorageUserLanguage(newLanguage);
      this.$store.commit('setUserIdentity', { ...this.userIdentity, langKey: newLanguage });
      this.currentLanguage = newLanguage;
      this.langKey = newLanguage;
    }
  }

  // public createUser(): IUserModel {
  //   return {
  // ...new UserModel(),
  // id: this.user.id,
  // login: this.user.login,
  // password: this.user.password,
  // firstName: this.user.firstName,
  // lastName: this.lastName,
  // email: this.email,
  // phoneCountry: this.user.phoneCountry,
  // phoneNumber: this.user.phoneNumber,
  // imageUrl: '',
  // activated: this.user.activated,
  // langKey: this.langKey,
  // activationKey: this.user.activationKey,
  // resetKey: this.user.resetKey,
  // createdBy: this.user.createdBy,
  // createdDate: this.user.createdDate,
  // resetDate: this.user.resetDate,
  // lastModifiedBy: this.user.lastModifiedBy,
  // lastModifiedDate: this.user.lastModifiedDate,
  // termOfService: this.user.term_of_service,
  // receiveNews: this.user.receive_news,
  //   };
  // }

  // public updateUser(language?) {
  //   const formData = new FormData();
  //   // formData.append('file', this.fileAvatar);
  //   const user = this.createUser();
  //   formData.append('user', JSON.stringify(user));
  //   const config = {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   };
  //   axios
  //     .put<IUserModel>('/api/admin/users', formData)
  //     .then(res => {
  //       this.isEditing = !this.isEditing;
  //       this.user = res.data;
  //       this.$emit('refreshConnectome', res.data);
  //       if (!language) {
  //         this.$bvModal.hide('modal-user-info');
  //         this.$bvToast.toast('Edit User Success', {
  //           toaster: 'b-toaster-bottom-right',
  //           title: 'Success',
  //           variant: 'success',
  //           solid: true,
  //           autoHideDelay: 5000,
  //         });
  //       }
  //     })
  //     .catch(err => {
  //       this.$bvToast.toast(err.response?.data?.title, {
  //         toaster: 'b-toaster-bottom-right',
  //         title: 'Error',
  //         variant: 'danger',
  //         solid: true,
  //         autoHideDelay: 5000,
  //       });
  //     });
  // }

  // handleDateChange() {
  //   this.isDatePicker = false;
  //   const from = this.datePicker.from;
  //   const until = this.datePicker.to;
  //
  //   if (from > until) {
  //     this.isDatePicker = true;
  //     return;
  //   }
  //   this.fromDate = new Date(from).toISOString();
  //   this.untilDate = new Date(until).toISOString();
  //   // this.dateTime = [];
  //   // this.dateTime.push({ choosePeriodFrom: this.fromDate }, { choosePeriodUntil: this.untilDate });
  //   this.activateSDate = false;
  //   // const time = { text: 'choosePeriod', filter: { field: FEED_FILTER.recommendDate, value: { from: new Date(from).toISOString(), to: new Date(to).toISOString() } }, selected: true }
  //   // this.handleFilterValue('period', time);
  //   const nameToShow = moment(from).format(from) + '~' + moment(until).format(until);
  //   const keySearch = new KeySearch('period', nameToShow, { from, until }, 'choosePeriod');
  // }

  changeDateTime(item) {
    let isCheckChoosePeriod = false;
    this.untilDate = '';
    this.fromDate = '';
    this.dateTime = [];
    this.dateTime = [...item];
    this.dateTime.forEach(item => {
      if (Object.keys(item)[0].toLowerCase().includes('until')) {
        const until = Object.keys(item)[0];
        this.untilDate = item[until];
      }
      if (Object.keys(item)[0].toLowerCase().includes('from')) {
        const from = Object.keys(item)[0];
        this.fromDate = item[from];
      }
      if (Object.keys(item)[0].toLowerCase().includes('chooseperiod')) {
        isCheckChoosePeriod = true;
      }
    });
    if (isCheckChoosePeriod) {
      // this.isDisabledPeriod = true;
      this.datePicker.from = new Date(this.fromDate).toISOString().split('T')[0];
      this.datePicker.to = new Date(this.untilDate).toISOString().split('T')[0];
    }
  }

  // setTheme(colorThemeInput) {
  //   localStorage.setItem('theme', colorThemeInput);
  //   document.documentElement.setAttribute('data-theme', colorThemeInput);
  //   // @ts-ignore
  //   $('.go-theme-switch input[type="checkbox"]').checked = colorThemeInput === 'dark';
  // }

  // async changUserColorThemDsNavBar(userIdInput: string, colorThemeInput: string) {
  //   // loading
  //   // todo
  //
  //   if (userIdInput && colorThemeInput && !this.isLoadingChangeColor) {
  //     this.isLoadingChangeColor = true;
  //
  //     try {
  //       await this.userMyPageService().callApiChangeUserColorTheme(colorThemeInput);
  //     } catch (e) {
  //       this.$bvToast.toast(e.response?.data?.title, {
  //         toaster: 'b-toaster-bottom-right',
  //         title: 'Error',
  //         variant: 'danger',
  //         solid: true,
  //         autoHideDelay: 5000,
  //       });
  //     } finally {
  //       // todo
  //     }
  //   }
  // }

  fetchTotalResource(): void {
    this.briefingService()
      .getAllResourceData()
      .then(resp => {
        this.setTotalResources(resp.data.body.body.totalElements);
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleCloseBackDrop() {
    let intervalCloseBackDropByButton = setInterval(() => {
      const button = document.getElementById('buttonCloseBackDrop');

      if (button) {
        button.click();
        clearInterval(intervalCloseBackDropByButton);
        intervalCloseBackDropByButton = null;
      }

      setTimeout(() => {
        clearInterval(intervalCloseBackDropByButton);
        intervalCloseBackDropByButton = null;
      }, 300);
    }, 100);

    let intervalCloseBackDropByClass = setInterval(() => {
      const backdrop = document.querySelector('.modal-backdrop');

      if (backdrop) {
        backdrop.remove();
        clearInterval(intervalCloseBackDropByClass);
        intervalCloseBackDropByClass = null;
      }

      setTimeout(() => {
        clearInterval(intervalCloseBackDropByClass);
        intervalCloseBackDropByClass = null;
      }, 300);
    }, 100);
  }

  handleHomeClickHome() {
    this.$root.$emit('getSuggestQuestion');
    this.briefingService().accessHome();
  }

  handleGoToUrlRequiredLogin(url?: string) {
    const isGuest = checkIsGuestAccount();

    if (isGuest === undefined || isGuest === null || isGuest === false) {
      if (url?.trim()?.length > 0) {
        this.$router.push(url);
      }
    } else if (isGuest !== undefined && isGuest !== null && isGuest === true) {
      if (
        (this.getIsShowPopupLogin === undefined || this.getIsShowPopupLogin === false) &&
        (this.getIsShowPopupRegister === undefined || this.getIsShowPopupRegister === false)
      ) {
        this.setIsShowPopupRequiredLogin(true);
      }
    }
  }
}
